import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { concat, EMPTY, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'eos-configurable-type-ahead',
  templateUrl: './configurable-type-ahead.component.html',
  styleUrls: ['./configurable-type-ahead.component.css']
})
export class ConfigurableTypeAheadComponent extends FieldType implements OnInit, OnDestroy {
  onDestroy$ = new Subject<void>();
  searchInput$ = new Subject<string>();
  options$;
  showLoader = false;
  constructor() {
    super();
   }

  ngOnInit() {
    this.options$ = concat(
      of([]),
      this.searchInput$.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter(v => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => this.showLoader = true),
        switchMap(term => 
            this.to.typeAheadEndPoint(term).pipe(
              catchError(() => of([])),
              tap(() => this.showLoader = false)
            )
        )
      )
    );
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }

}
